/** Простейшая проверка на то, что код выполняется в браузере а не Nodejs **/
export const isBrowser = () => typeof window !== 'undefined';
